export default "__VITE_PUBLIC_ASSET__76926e6e__"